/* eslint-disable global-require */
const AppIcons = {
  sampleIcon: require('./sample.ico'),
  logo: require('../Logo.png'),
  BlueLogo: require('../BlueLogo.png'),
  loginBG: require('../login.png'),
  banner: require('../banner.png'),
  story: require('../story.png'),
  mission: require('./mission.png'),
  vision: require('./vision.png'),
  Video: require('../Video.png'),
  homeProj1: require('../homeProj/proj1.png'),
  homeProj2: require('../homeProj/proj2.png'),
  homeProj3: require('../homeProj/proj3.png'),
  homeProj4: require('../homeProj/proj4.png'),
  homeProj5: require('../homeProj/proj5.png'),

  oilGas: require('../homeService/oilGas.png'),
  blue: require('../homeService/blue.png'),
  green: require('../homeService/green.png'),
  hotel: require('../homeService/hotel.png'),
  minerals: require('../homeService/minerals.png'),
  security: require('../homeService/security.png'),
  smart: require('../homeService/smart.png'),
  wealth: require('../homeService/wealth.png'),
  globalPresence: require('../globalPresence.png'),
  aboutBanner: require('../aboutBanner.png'),
  childrens: require('../childrens.png'),

  auther: require('../article/auther.png'),
  singleArticle: require('../article/singleArticle.png'),
  newArticle: require('../article/newArticle.png'),
  article1: require('../article/article1.png'),
  article2: require('../article/article2.png'),
  article3: require('../article/article3.png'),

  partner1: require('../partners/partner1.png'),
  partner2: require('../partners/partner2.png'),
  partner3: require('../partners/partner3.png'),
  partner4: require('../partners/partner4.png'),
  partner5: require('../partners/partner5.png'),
  partner6: require('../partners/partner6.png'),
  partner7: require('../partners/partner7.png'),

  team1: require('../team/team1.png'),
  team2: require('../team/team2.png'),
  team3: require('../team/team3.png'),
  objectivesBanner: require('../objectivesBanner.png'),
  projectBanner1: require('../projects/projectBanner1.png'),
  projAbout: require('../projects/projAbout.png'),
  waterBanner: require('../projects/waterBanner.png'),
  waterAbt: require('../projects/waterAbt.png'),
  waterProjVolunteer: require('../projects/waterProjVolunteer.png'),
  projectImg1: require('../projects/projectImg1.png'),
  projectImg2: require('../projects/projectImg2.png'),
  projectImg3: require('../projects/projectImg3.png'),
  empoweringWomens: require('../projects/empoweringWomens.png'),
  waterEnergy: require('../projects/waterEnergy.png'),
  futureOfKids: require('../projects/futureOfKids.png'),

  joinCommunityBanner: require('../joinCommunityBanner.png'),
  joinCommunityVision: require('../joinCommunityVision.png'),
  articlesDetails: require('../articlesDetails.png'),
  contactUS: require('../contactUS.png'),
  contactUsBG: require('../contactUsBG.png'),

  forVolunteer: require('../forVolunteer.png'),


  
  rigisterBG: require('../register.jpg'),

};
export default AppIcons;
/* eslint-enable global-require */
